<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
    };
  },
  methods: {
    $Can(permissionName) {
      if (
        this.userData.role === "supermanager" ||
        this.userData.role === "admin"
      ) {
        return true;
      } else {
        return localStorage.getItem("userPerms").includes(permissionName)
          ? true
          : false;
      }
    },
    // Returns true if current user is listed as an event admin
    $IsEventAdmin(eventOrAdmins) {
      try {
        const user = JSON.parse(localStorage.getItem("userData")) || {};
        const currentUserId = user && (user.id || user.user_id);
        if (!currentUserId || !eventOrAdmins) return false;

        let admins = [];
        if (Array.isArray(eventOrAdmins)) {
          admins = eventOrAdmins;
        } else if (eventOrAdmins.event_admins) {
          admins = eventOrAdmins.event_admins;
        } else if (eventOrAdmins.admins) {
          admins = eventOrAdmins.admins;
        } else if (eventOrAdmins.eventAdmins) {
          admins = eventOrAdmins.eventAdmins;
        }

        if (!Array.isArray(admins) || admins.length === 0) return false;

        const adminIds = admins
          .map((a) => (a && typeof a === "object" ? a.id : a))
          .filter((id) => id !== null && id !== undefined);

        return adminIds.some((id) => String(id) == String(currentUserId));
      } catch (e) {
        return false;
      }
    },

    // Event-aware permission: short-circuits for system admins and event admins
    $CanEvent(permissionName, eventOrAdmins) {
      const role = (this.userData && this.userData.role) || "";
      if (["supermanager", "admin", "Administrator"].includes(role)) {
        return true;
      }
      if (this.$IsEventAdmin(eventOrAdmins)) return true;
      return this.$Can(permissionName);
    },
    $CanViewMenu(item) {
      if (
        this.userData.role === "supermanager" ||
        this.userData.role === "admin"
      ) {
        return true;
      } else {
        return this.$Can(item.Permission);
      }
    },
  },
};
</script>
